import { useDispatch, useSelector } from 'react-redux';
import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
import { redirectToUrl } from '../utils/redirectToUrl';
import { getFallbackOnboardingUrl } from './getFallbackOnboardingUrl';
import { useLoginRedirect } from './useLoginRedirect';
export const useRedirects = () => {
  const dispatch = useDispatch();
  const portalId = useSelector(getPortalId);
  const hublet = useSelector(getHublet);
  const {
    redirectToLogin
  } = useLoginRedirect();

  const redirectTo = url => {
    dispatch(redirectToUrl(url));
  };

  const redirectGettingStartedUserGuide = () => {
    const url = getFallbackOnboardingUrl(portalId, hublet);
    redirectToLogin({
      redirectUrl: url,
      hublet
    });
  };

  return {
    redirectToLogin,
    redirectTo,
    redirectGettingStartedUserGuide
  };
};